import React from 'react'
import { useTheme } from '@mui/material'

import { InfoCircle } from 'iconsax-react'
import { useVerification } from '@SonarCX/providers/VerificationProvider'
import useStyles from './styles'

const TimelineVerificationHeader = () => {
  const theme = useTheme()

  const { link, owner } = useVerification()

  const classes = useStyles()

  if (!owner) {
    return null
  }

  return (
    <div className={classes.root}>
      <div className={classes.warning}>
        <InfoCircle size={theme.size.base} className='icon' />
        Warning: Participant is not verified as {owner.name}
      </div>

      <div>{link}</div>
    </div>
  )
}

export default TimelineVerificationHeader
